export var isNumber = function isNumber(x) {
  return typeof x === "number";
};
export var isFunction = function isFunction(x) {
  return typeof x === "function";
};
export var isObject = function isObject(x) {
  return Object.prototype.toString.call(x) === "[object Object]";
};
export var toArray = function toArray(arrayLike) {
  return Array.prototype.slice.apply(arrayLike);
};